/* R815 · VIN-Pflichtfeld (Etikett vin-pflicht) — gehört zu snippets/usparts-vin-pflicht.liquid.
   Keine Bibliothek. Regeln (Marcel 03.11.2026):
     · genau 17 Zeichen, Großbuchstaben, ohne I, O, Q
     · Leerzeichen (und alles, was kein Buchstabe oder keine Ziffer ist) wird beim Tippen und Einfügen entfernt
     · ohne gültige VIN geht das Formular nicht ab, dazu ein freundlicher Hinweis
   Die Prüfziffer (9. Stelle) ist nur ein Hinweis, nie eine Sperre: Fahrzeuge außerhalb Nordamerikas
   müssen sie nicht erfüllen. Gesperrt wird nur nach Form (17 Zeichen, erlaubte Zeichen). */
(function () {
  'use strict';
  if (window.__uspVinPflicht) { if (window.__uspVinPflicht.init) window.__uspVinPflicht.init(); return; }

  var WERT = { A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8, J: 1, K: 2, L: 3, M: 4, N: 5, P: 7, R: 9, S: 2, T: 3, U: 4, V: 5, W: 6, X: 7, Y: 8, Z: 9 };
  var GEWICHT = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];

  function normal(v) { return String(v == null ? '' : v).toUpperCase().replace(/[^A-Z0-9]/g, ''); }

  /* Prüfziffer nach ISO 3779 / 49 CFR 565: Summe aus Wert × Gewicht, Rest durch 11, 10 = „X“. */
  function pruefzifferStimmt(v) {
    var summe = 0, i, c, w;
    for (i = 0; i < 17; i++) {
      c = v.charAt(i);
      w = /[0-9]/.test(c) ? Number(c) : WERT[c];
      if (w == null) return true; // unbekanntes Zeichen: nicht beurteilen
      summe += w * GEWICHT[i];
    }
    var rest = summe % 11;
    return v.charAt(8) === (rest === 10 ? 'X' : String(rest));
  }

  /* art: leer | zeichen (I/O/Q) | laenge | ok */
  function beurteile(v) {
    if (!v) return 'leer';
    if (/[IOQ]/.test(v)) return 'zeichen';
    if (v.length !== 17) return 'laenge';
    return 'ok';
  }

  function aufbauen(wurzel) {
    if (wurzel.__uspVinInit) return;
    wurzel.__uspVinInit = true;
    var feld = wurzel.querySelector('[data-usp-vinf-feld]');
    var zaehler = wurzel.querySelector('[data-usp-vinf-zaehler]');
    var meldung = wurzel.querySelector('[data-usp-vinf-meldung]');
    var form = feld && (feld.form || feld.closest('form'));
    if (!feld || !meldung) return;
    var d = wurzel.dataset || {};
    var gezeigt = false; // Fehler erst nach dem Verlassen des Feldes oder dem ersten Absendeversuch (I/O/Q sofort)

    // Eigene Meldung statt der Sprechblase des Browsers; ohne Skript greifen required + pattern.
    if (form) form.noValidate = true;

    function text(art, v) {
      if (art === 'leer') return d.msgLeer || '';
      if (art === 'laenge') return (d.msgLaenge || '').replace('__N__', String(v.length));
      if (art === 'zeichen') return d.msgZeichen || '';
      return '';
    }

    function zeichnen() {
      var v = normal(feld.value);
      var art = beurteile(v);
      var ok = art === 'ok';
      var warn = ok && !pruefzifferStimmt(v);
      var zeigeFehler = !ok && (gezeigt || art === 'zeichen');
      if (zaehler) zaehler.textContent = v.length + ' / 17';
      wurzel.classList.toggle('is-ok', ok && !warn);
      wurzel.classList.toggle('is-warn', warn);
      wurzel.classList.toggle('is-fehler', zeigeFehler);
      feld.setAttribute('aria-invalid', zeigeFehler ? 'true' : 'false');
      if (zeigeFehler) { meldung.textContent = text(art, v); meldung.hidden = false; }
      else if (warn) { meldung.textContent = d.msgZiffer || ''; meldung.hidden = !d.msgZiffer; }
      else { meldung.textContent = ''; meldung.hidden = true; }
      return ok;
    }

    function bereinigen() {
      var roh = feld.value;
      var pos = feld.selectionStart;
      var neu = normal(roh);
      if (neu !== roh) {
        var vorCursor = (typeof pos === 'number') ? normal(roh.slice(0, pos)).length : neu.length;
        feld.value = neu;
        try { feld.setSelectionRange(vorCursor, vorCursor); } catch (e) { /* manche Browser: nur bei Fokus */ }
      }
    }

    feld.addEventListener('input', function () { bereinigen(); zeichnen(); });
    feld.addEventListener('change', function () { bereinigen(); zeichnen(); });
    feld.addEventListener('blur', function () {
      bereinigen();
      if (feld.value) gezeigt = true; // ein leeres Feld beim Weiterklicken nicht anmeckern
      zeichnen();
    });

    if (form) {
      // Capture-Phase und stopImmediatePropagation: kein anderes Skript soll das Formular trotzdem absenden.
      form.addEventListener('submit', function (e) {
        bereinigen();
        gezeigt = true;
        if (zeichnen()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        try { feld.focus({ preventScroll: true }); } catch (x) { feld.focus(); }
        var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        try { wurzel.scrollIntoView({ block: 'center', behavior: ruhig ? 'auto' : 'smooth' }); } catch (y) { wurzel.scrollIntoView(); }
      }, true);
    }

    zeichnen();
  }

  function init() {
    var alle = document.querySelectorAll('[data-usp-vinf]');
    for (var i = 0; i < alle.length; i++) aufbauen(alle[i]);
  }

  window.__uspVinPflicht = { init: init, normal: normal, beurteile: beurteile, pruefzifferStimmt: pruefzifferStimmt };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
